var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-page',{staticClass:"flex column page-layout page-not-found"},[_c('q-icon',{staticStyle:{"font-size":"6em"},attrs:{"name":"sentiment_dissatisfied"}}),_c('h1',[_vm._v("Page Not Found")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }